var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 481,
    viewBox: "0 0 350 481",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 250.228C30 247.583 31.3077 245.109 33.4933 243.618L48.5067 233.382C50.6923 231.892 52 229.417 52 226.772V70C52 65.5817 55.5817 62 60 62H302C306.418 62 310 65.5817 310 70V319.686C310 321.808 309.157 323.843 307.657 325.343L293.343 339.657C291.843 341.157 289.808 342 287.686 342H38C33.5817 342 30 338.418 30 334V250.228Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlight);
export default __webpack_public_path__ + "static/media/highlight.352dd5636c9fac8901e1e6a816db2f58.svg";
export { ForwardRef as ReactComponent };